import React from 'react';
import Cookies from 'universal-cookie';
import { connect } from 'react-redux';
import { showCart, hideCart, restore } from './actions';
import CartIcon from 'images/icons/cart.svg?react-svg';

let CartButton = class CartButton extends React.Component {
  constructor(props) {
    super(props);
    this.toggleCart = this.toggleCart.bind(this);
  }

  /* TODO: move cart restoration to server */
  componentDidMount() {
    const cookies = new Cookies();
    const anonToken = cookies.get('anon-user-token');
    const userToken = cookies.get('user-token');
    if (anonToken || userToken) this.props.restore();
  }

  toggleCart(e) {
    e.stopPropagation();
    this.props.show ? this.props.hideCart() : this.props.showCart();
  }

  render() {
    const active = !!this.props.products.length;
    const className = `cart-button ${active ? 'active' : ''}`;
    const sumQuantity = this.props.products.reduce((sum, i) => sum + i.qty, 0);

    return (
      <button className={className} onClick={this.toggleCart}>
        <div className="cart-icon-container">
          <CartIcon width={30} height={30} />
        </div>
        <div className="cart-text">{sumQuantity || ''}</div>
      </button>
    );
  }
};

CartButton = connect(
  state => ({
    show: state.cart.show,
    products: state.cart.products
  }),
  { showCart, hideCart, restore }
)(CartButton);

export default CartButton;



// WEBPACK FOOTER //
// ./shared/components/cart/button.js